var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.isGrantedAtOnceProject
        ? _c("p", [
            _vm._v(
              _vm._s(
                _vm.$t(
                  "Feedback.AidApplication.AidProposalGrantedAtOnceProject.Description1"
                )
              )
            )
          ])
        : _c("p", [
            _vm._v(
              _vm._s(_vm.$t("Feedback.AidApplication.AidProposal.Description1"))
            )
          ]),
      _vm._v(" "),
      _vm.isApproved
        ? _c("p", [
            _vm._v(
              _vm._s(_vm.$t("Feedback.AidApplication.AidProposal.Description2"))
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.currentUser.organisationName
        ? _c("text-label-row", {
            attrs: {
              title: "OrganisationName",
              bold: true,
              value: _vm.currentUser.organisationName
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.currentUser.organisationNumber
        ? _c("text-label-row", {
            attrs: {
              title: "Pdf.OrganisationNumber",
              bold: true,
              value: _vm.getNumberAsString(_vm.currentUser.organisationNumber)
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("text-label-row", {
        attrs: {
          title: "Feedback.AidApplication.AidTarget",
          bold: true,
          value: _vm.record.aidTargetNumber
        }
      }),
      _vm._v(" "),
      _vm.purpose
        ? _c("text-label-row", {
            attrs: { title: "Purpose", bold: true, value: _vm.purpose }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.isApproved && _vm.model.feedback.decisionTerms
        ? _c("text-label-row", {
            attrs: {
              title: "Feedback.AidApplication.AidTargetDecisionTerms",
              bold: true,
              value: _vm.model.feedback.decisionTerms
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("text-label-row", {
        attrs: {
          title: _vm.requestedAmountTitle,
          bold: true,
          formatNumber: true,
          doNotUseResources: true,
          sign: "€",
          value: _vm.getNumberAsString(_vm.model.feedback.requestedAmount)
        }
      }),
      _vm._v(" "),
      _c("text-label-row", {
        attrs: {
          title: _vm.proposedAmountTitle,
          bold: true,
          formatNumber: true,
          doNotUseResources: true,
          sign: "€",
          value: _vm.getNumberAsString(_vm.model.feedback.proposedAmount)
        }
      }),
      _vm._v(" "),
      _vm.isGrantedAtOnceProject
        ? _c(
            "div",
            [
              _vm.hasValue(_vm.model.feedback.proposedAmount2)
                ? _c("text-label-row", {
                    attrs: {
                      title: _vm.$t(
                        "Feedback.AidApplication.AidProposalGrantedAtOnceProject.ProposedAmount",
                        { 0: _vm.record.year + 1 }
                      ),
                      bold: true,
                      formatNumber: true,
                      doNotUseResources: true,
                      sign: "€",
                      value: _vm.getNumberAsString(
                        _vm.model.feedback.proposedAmount2
                      )
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.hasValue(_vm.model.feedback.proposedAmount3)
                ? _c("text-label-row", {
                    attrs: {
                      title: _vm.$t(
                        "Feedback.AidApplication.AidProposalGrantedAtOnceProject.ProposedAmount",
                        { 0: _vm.record.year + 2 }
                      ),
                      bold: true,
                      formatNumber: true,
                      doNotUseResources: true,
                      sign: "€",
                      value: _vm.getNumberAsString(
                        _vm.model.feedback.proposedAmount3
                      )
                    }
                  })
                : _vm._e()
            ],
            1
          )
        : _vm.isApproved
        ? _c(
            "div",
            [
              _vm.hasValue(_vm.model.feedback.plannedAid1)
                ? _c("text-label-row", {
                    attrs: {
                      title: _vm.$t("Feedback.AidApplication.PlannedAid", {
                        0: _vm.record.year + 1
                      }),
                      bold: true,
                      formatNumber: true,
                      doNotUseResources: true,
                      sign: "€",
                      value: _vm.getNumberAsString(
                        _vm.model.feedback.plannedAid1
                      )
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.hasValue(_vm.model.feedback.plannedAid2)
                ? _c("text-label-row", {
                    attrs: {
                      title: _vm.$t("Feedback.AidApplication.PlannedAid", {
                        0: _vm.record.year + 2
                      }),
                      bold: true,
                      formatNumber: true,
                      doNotUseResources: true,
                      sign: "€",
                      value: _vm.getNumberAsString(
                        _vm.model.feedback.plannedAid2
                      )
                    }
                  })
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isApproved
        ? _c(
            "div",
            [
              _vm.model.isB
                ? _c("text-label-row", {
                    attrs: {
                      title: "Feedback.AidPercent",
                      bold: true,
                      sign: "%",
                      value: _vm.getNumberAsString(
                        _vm.model.feedback.aidPercent
                      )
                    }
                  })
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.record.feedback
        ? _c("text-label-row", {
            attrs: {
              title: "Feedback.AidApplication.AidProposal.Feedback",
              bold: true,
              value: _vm.record.feedback
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.isApproved && _vm.model.feedback.aidTargetInstructions
        ? _c("text-label-row", {
            attrs: {
              title: "Feedback.AidApplication.AidTargetInstructions",
              bold: true,
              value: _vm.model.feedback.aidTargetInstructions
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("p", { staticClass: "mt-5" }, [
        _vm._v(_vm._s(_vm.$t("Feedback.AidApplication.AidDecision.MoreInfo")))
      ]),
      _vm._v(" "),
      _vm.model.feedback.draftsman
        ? _c("text-label-row", {
            attrs: {
              title: "Feedback.Draftsman",
              bold: true,
              value: _vm.model.feedback.draftsman.contactInfo
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.model.feedback.inspector
        ? _c("text-label-row", {
            attrs: {
              title: "Feedback.Inspector",
              bold: true,
              value: _vm.model.feedback.inspector.contactInfo
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.model.feedback.supervisor
        ? _c("text-label-row", {
            attrs: {
              title: "Feedback.Supervisor",
              bold: true,
              value: _vm.model.feedback.supervisor.contactInfo
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("p", { staticClass: "mt-5 mb-5" }, [
        _vm._v(
          _vm._s(_vm.$t("Feedback.AidApplication.AidProposal.Description3"))
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }